import { blueScale, yellowScale } from './colors';
export const brandAltair = {
    accentPrimary: yellowScale[500],
    accentSecondary: blueScale[500],
};
